
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"33","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_222_4117)","stroke":"#94A3B8","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M11 17.802l11.282 9.891a1 1 0 001.637-.526L29 5.096a.125.125 0 00-.168-.144L3.5 14.866a.779.779 0 00.125 1.49L11 17.802zM11 17.803L28.926 4.955"}}),_c('path',{attrs:{"d":"M16.546 22.666l-3.826 3.97a1 1 0 01-1.72-.692v-8.141"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_222_4117"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .943)","d":"M0 0h32v32H0z"}})])])])
          )
        }
      }
    